import React from "react"
import {  isSelected, modules, panels, isChecked } from "../config/Helpers";
import axios from "axios";
import { HashLink as Link } from 'react-router-hash-link';

const postUrlWidgets = "http://127.0.0.1:8000/api/v1/widgets/pruebas";

class Header extends React.Component{
  constructor(props){
    super(props);
    this.state = {
      current_hotel    : { key  : "Hotels", value : "all" },
      current_module   : { text : "REVENUE INTELLIGENCE", icon: "icon-marketing-active", value : 1 },
      //current_panel    : { text : "LEAD TIME" , icon: "icon-leadtime-active", value : "lead-time" },
      current_panel    : { text : "FLASH SUMMARY" , icon: "icon-summary-active", value : "review" },
      module_menu_show : "hide-panel",
      panel_menu_show  : "hide-panel",
      hotel_menu_show  : "hide-panel",
      active_hotels    : {},
      request_status : "hide",
      request_cancel : null
    };
  }
  setDefaultValues(){
    this.setState({
      current_hotel    : { key  : "Hotels", value : "all" },
      current_module   : { text : "REVENUE INTELLIGENCE", icon: "icon-marketing-active", value : 1 },
      //current_panel    : { text : "LEAD TIME" , icon: "icon-leadtime-active", value : "lead-time" },
      current_panel    : { text : "FLASH SUMMARY" , icon: "icon-summary-active", value : "review" },
      module_menu_show : "hide-panel",
      panel_menu_show  : "hide-panel",
      hotel_menu_show  : "hide-panel",
      active_hotels    : {},
      request_status : "hide",
      request_cancel : null
    })
  }
  handleClickMenu(name) {
    if(this.state.request_status === "hide"){
      this.props.hideSelects();
      switch (name) {
        case "module_menu_show":
          this.state.module_menu_show === "hide-panel" ? this.setState({ module_menu_show : "" }) : this.setState({ module_menu_show : "hide-panel" });
        break;
        case "panel_menu_show":
          this.state.panel_menu_show === "hide-panel" ? this.setState({ panel_menu_show : "" }) : this.setState({ panel_menu_show : "hide-panel" });
        break;
        case "hotel_menu_show":
          this.setState({ 
            hotel_menu_show : this.state.hotel_menu_show === "hide-panel" ? "" : "hide-panel",
            active_hotels : Object.assign({}, this.props.current_filter_properties)
          });
          break;
        case "apply-hotels":
          this.setState({
            hotel_menu_show : this.state.hotel_menu_show === "hide-panel" ? "" : "hide-panel"
          }, function(){
            this.props.setFilterBubble(null, this.state.active_hotels, null, "property")
          })
        break;
      }
    }
  }

  handleClickMenuItem(item, menu) {

    const CancelToken = axios.CancelToken;
    let request_cancel = CancelToken.source();
    let self = this;

    

    switch (menu) {
      case "menu_hotel":
        let array_elements  = this.props.current_filter_properties
        
        if(array_elements[item.value] === undefined)
        {
          this.props.setFilterBubble(item.text, item.value, "hide", "property")
        }
        break;
      case "menu_module":
        if(item.value === 1){
          this.setState({current_module : { text : item.text, icon: item.icon, value : item.value } })
        }
      break;
      case "menu_panel":
        if (item.value !== 5 && item.value !== 6 && item.value !== 7 && item.value !== 8) {
          if(this.state.current_panel.text !== item.text){
            this.props.setTypePanel(item.value)
            this.setState({current_panel : { text : item.text, icon: item.icon, value : item.value } })
          }
        }
      break;
    }
  } 
  handleLogout(event) {
    event.preventDefault();
    localStorage.removeItem("api_token");
    localStorage.removeItem("name");
    localStorage.removeItem("email");
    window.location.reload();
    this.props.setSession(false)
  }

  addHotel(hotel){
    let active_hotels = this.state.active_hotels;
    if(active_hotels[hotel.value] === undefined){
      active_hotels[hotel.value] = hotel;
    }else{
      delete active_hotels[hotel.value];
    }
    this.setState({
      active_hotels : active_hotels
    })
  }
  render(){
    let hotels = this.props.hotels;
    
    const listHotels = Object.keys(hotels).map((key, index) =>
      <li key={"list-hotel-"+index} onClick={this.addHotel.bind(this, {'value' : hotels[key]._id, "hotel" : hotels[key].name})}>
        <span children={hotels[key].name} />
        <input type="checkbox" 
                value={ hotels[key]._id}
                checked={isChecked(this.state.active_hotels, hotels[key]._id)} 
                //onClick={this.handleClickMenuItem.bind(this, item.key, item.value, "days")}
            />
        <span className="checkmark"></span>
      </li>
    );

    const listModules = modules.map((item, index) => {
      let enabled = "";
      if (item.value !== 1){
        enabled = "disabled"
      }
      return (<li key={"list-module-" + index} className={"icon-grouppanel " + isSelected(item.value, this.state.current_module.value) + " " + enabled }
      onClick={this.handleClickMenuItem.bind(this, { text: item.text, icon: item.icon + "-active", value: item.value }, "menu_module")}>
        <span className={item.icon}></span> <span>{item.text}</span>
      </li>)
    });

    const listPanels = panels.map((item, index) =>{
      let enabled = "";
      if (item.value === 5 || item.value === 6 || item.value === 7 || item.value === 8) {
        enabled = "disabled"
      }
      return (<li key={"list-panel-" + index} className={"icon-grouppanel " + isSelected(item.value, this.state.current_panel.value ) + " " + enabled }
      onClick={this.handleClickMenuItem.bind(this, { text: item.text, icon: item.icon + "-active", value: item.value }, "menu_panel")}>
        <span className={item.icon}></span> <span>{item.text}</span>
      </li>)
    });

    return(
      <header id="main-header">
        <nav>
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-3">
                <Link to="/"><span className="logo-header"> </span></Link>
              </div>
              <div className="col-md-2 hotel-filter">
                <div className={"request-load " + this.state.request_status}><span>LOADING...</span></div>
                <div className={"select-style " + this.state.hotel_menu_show}>
                  <span className="white">
                    <span onClick={this.handleClickMenu.bind(this, "hotel_menu_show")}>{this.state.current_hotel.key}</span>
                    <ul>
                      {listHotels}
                      <li onClick={this.handleClickMenu.bind(this, "apply-hotels")} className="btn-apply-hotels">APPLY</li>
                    </ul>
                  </span>
                </div>
              </div>
              <div className="col-md-2 segment-filter" onClick={this.handleClickMenu.bind(this, "module_menu_show")}>
              <div className={"request-load " + this.state.request_status}><span>LOADING...</span></div>
                <span className="invert-title">MODULE</span>
                <div className="custom-select icon-component">
                  <span className={this.state.current_module.icon}></span>
                  <span className={"for-select " + this.state.module_menu_show}>{this.state.current_module.text}</span>
                </div>
                  <div className={"group-panel " + this.state.module_menu_show}>
                    <ul>
                      {listModules}
                    </ul>
                  </div>
              </div>
              <div className="col-md-2 segment-filter" onClick={this.handleClickMenu.bind(this, "panel_menu_show")}>
                <div className={"request-load " + this.state.request_status}><span>LOADING...</span></div>
                <span className="invert-title">PANEL</span>
                <div className="custom-select icon-component">
                  <span className={this.state.current_panel.icon}></span>
                  <span className={"for-select " + this.state.panel_menu_show}>{this.state.current_panel.text}</span>
                </div>
                <div  className={"group-panel " + this.state.panel_menu_show}>
                  <ul>
                    {listPanels}
                  </ul>
                </div>
              </div>
              <div className="col-md-3 segment-filter ">
                <span className="invert-title segment-reserva"></span>
                <div className="row">
                <div className="col-md-12">
              </div>
                  <div className="col-md-2">
                    <div className="segment-list">
                    </div>
                  </div>
                  <div className="col-md-10">
                   {/*<div className="profile-options">
                      <div className="icon-component">
                        <span className="icon-notify"></span>
                      </div>
                      <div className="icon-component">
                        <span className="icon-news"></span>
                      </div>
                      <div className="icon-component">
                        <Link to="/setup"><span className="icon-settings"></span></Link>
                      </div>
                      <div className="icon-component" onClick={this.handleLogout.bind(this)}>
                        <span className="icon-logout"></span>
                      </div>
                  </div>*/}
                  <div className="profile-options">
                      <div className="icon-component" onClick={() => { this.props.app.alertState("demo_version") }}>
                        <span className="icon-notify"></span>
                      </div>
                      <div className="icon-component" onClick={() => { this.props.app.alertState("demo_version") }}>
                        <span className="icon-news"></span>
                      </div>
                      <div className="icon-component" onClick={() => { this.props.app.alertState("demo_version") }}>
                        <span className="icon-settings"></span>
                      </div>
                      <div className="icon-component" onClick={() => { this.props.app.alertState("demo_version") }}>
                        <span className="icon-logout"></span>
                      </div>
                  </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </nav>
      </header>
    )
  }
};

export default Header


// WEBPACK FOOTER //
// ./src/Frontend/components/Header.js